import React from 'react';

const Spinner = ({ size = 'medium', color = 'black', fullScreen = false }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  const colorClasses = {
    black: 'border-black',
    white: 'border-white',
    blue: 'border-blue-500'
  };

  const containerClasses = fullScreen 
    ? 'fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/50'
    : 'absolute top-0 left-0 w-full h-[100vh] flex items-center justify-center';

  return (
    <div className={containerClasses}>
      <div
        className={`
          ${sizeClasses[size]}
          ${colorClasses[color]}
          border-4 border-t-transparent
          rounded-full
          animate-spin
        `}
      ></div>
    </div>
  );
};

export default Spinner;